<template>
  <div class="not_login_warehouse">
    <warehouse :not='true'></warehouse>
  </div>
</template>

<script>
import warehouse from '../placeOrder/warehouse'
export default {
  components: {
    warehouse
  }
}
</script>

<style lang='scss'>
.not_login_warehouse {
  width: 100%;
  height: 100vh;
}
</style>